<template>
  <div>

    <q-list v-if="fieldValue && fieldValue.accounts && fieldValue.accounts.length > 0"
            bordered separator padding class="rounded-borders q-mb-md">
      <template v-for="(place, place_index) in fieldValue.accounts"
                :key="place_index">
      <q-item clickable v-ripple   active-class="bg-teal-1 text-grey-8" :active="place_index === index">
        <q-item-section avatar top>
          <q-avatar icon="s_account_balance_wallet" color="grey" text-color="white" />
        </q-item-section>

        <q-item-section @click="selectAccount(place_index)">
          <q-item-label ><span class="q-mr-xs" v-if="fieldValue.accounts[place_index].bank">{{fieldValue.accounts[place_index].bank}}</span>
            <span class="q-mr-xs" v-if="fieldValue.accounts[place_index].account">{{mask(fieldValue.accounts[place_index].account, 4, '*')}}</span>
            <span class="q-mr-xs" v-if="fieldValue.accounts[place_index].type">{{options[fieldValue.accounts[place_index].type]}}</span>
            </q-item-label>
        </q-item-section>

        <q-item-section side @click.stop="confirmDeleteAlert(place_index)">
          <q-icon name="s_delete" color="amber"  />
        </q-item-section>
      </q-item>
      </template>
    </q-list>
<!--    <div class="text-subtitle1 q-py-sm ">Add Current or Previous Job</div>-->

    <div class="row  ">
      <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm q-gutter-y-md">


        <q-btn

            class="mw-form-v2-btn-submit "
            :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
            :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
            :round="!settings.theme.next.cs ? settings.theme.button.round: null"

            :outline="true"
            :push="!settings.theme.next.cs ? settings.theme.button.push: null"
            :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
            :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
            :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
            :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

            label="Add Liabilities" type="button" color="primary"
            :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            @click="AddItem()"
        >
        </q-btn>


      </div>
    </div>
    <q-field class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => isValid() || (field.required_text ? field.required_text :  'Must Enter at least one account_item')]">
    </q-field>


    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this liability {{options[fieldValue.accounts[confirmDeleteIndex] && fieldValue.accounts[confirmDeleteIndex].type]}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>


    <q-dialog v-model="editModalVisible" persistent>
      <q-card style="width: 800px; max-width: 100%;">
        <q-card-section class="">
          <ModuleBorrowerLiabilities ref="module" v-model="fieldValue.accounts[index]"></ModuleBorrowerLiabilities>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Remove this liability" @click="confirmDelete = true" color="primary"  />
          <q-btn flat label="Confirm" @click="Confirm()" color="primary"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

import ModuleBorrowerLiabilities from "@/components/modules/assets/ModuleBorrowerLiabilities";

import {mapActions} from "vuex";
export default {
  components: {
    ModuleBorrowerLiabilities,
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
        editModalVisible: false,
        confirm: false,
        confirmIndex: null,
        confirmIndexToClear: null,
        confirmDelete: false,
        confirmDeleteIndex: null,

        account_item: {
          type: "",
          company: "",
          account: "",
          monthly_payment: "",
          unpaid_balance: "",
          to_be_paid_off: false,
        },

        loan_types: {},
        accounts:[

        ],
        index: null,
        options: {
          'liability_revolving': 'Revolving (e.g., credit cards)',
          'liability_installment': 'Installment (e.g., car, student, personal loans)',
          'liability_open_30_day': 'Open 30-Day (balance paid monthly)',
          'liability_lease': 'Lease (not real estate)',
          'liability_Other': 'Other'
        },
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    mask(cc, num = 4, mask = '*') {
      return ('' + cc).slice(0, -num).replace(/./g, mask) + ('' + cc).slice(-num);
    },
    isValidAccount(index) {
      const account_item = this.fieldValue.accounts[index];
      return !(!account_item.address
          || !account_item.city
          || !account_item.state
          || !account_item.zip
          || account_item.years === ""
          || account_item.years === null
          || account_item.months === ""
          || account_item.months === null);

    },
    isValid () {
      return !this.field.required || this.fieldValue.accounts.length > 0;
    },
    Confirm() {
      this.$refs.module.validate().then(success => {
        if (success) {
          this.editModalVisible = false;
        }
      });
    },
    generateId() {
      return new Date().getTime() + '_' + Math.random();
    },
    AddItem() {
      this.index = this.fieldValue.accounts.push(Object.assign({id: this.generateId()}, this.account_item)) - 1;
      this.confirmDeleteIndex = this.index;
      this.confirmIndex = this.index;
      this.editModalVisible = true;
      //this.$refs.module.reset();
    },
    onSubmit() {
      this.fieldValue.accounts[this.index].valid = true;
      this.index = this.fieldValue.accounts.push(Object.assign({}, this.account_item)) - 1;
      this.$refs.form.reset();
    },
    onAddressSelected(account_item) {
      this.fieldValue.accounts[this.index].city = account_item.city;
      this.fieldValue.accounts[this.index].state = account_item.state;
      this.fieldValue.accounts[this.index].zip = account_item.zipcode;
    },
    selectAccount(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmDeleteIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.index = place_index;
      this.editModalVisible = true;
    },
    clearCurrentAndSwitch() {
      this.$refs.form.reset();
      this.index = this.confirmIndex;
      this.fieldValue.accounts.splice(this.confirmIndexToClear, 1);
    },
    confirmDeleteAlert(index) {

      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    deleteItem() {
      this.editModalVisible = false;
      // if(this.fieldValue.accounts.length === 1) {
      //   this.fieldValue.accounts.push(Object.assign({}, this.account_item));
      // }
      this.fieldValue.accounts.splice(this.confirmDeleteIndex, 1);
      this.index = this.fieldValue.accounts.length -1;

    },
    getFieldValueByFieldType(type) {
      for(let key in this.form.screens) {
        for (let keyF in this.form.screens[key].fields) {
          const field = this.form.screens[key].fields[keyF];
          if(type === field.type) {
            return this.fieldValues[field.id];
          }
        }
      }
      return null;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {


      if(this.fieldValue === undefined || this.fieldValue === null || this.fieldValue.accounts === undefined) {
        this.fieldValue = Object.assign({}, {accounts: []});
      }
      this.index = null;
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
</style>
